import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import "dayjs/locale/fr";

dayjs.locale("fr");
dayjs.extend(utc);
dayjs.extend(timezone);

export default dayjs;
